import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import BoilerDetail from '../../components/hot_water_system/BoilerDetail';
import { createBoiler } from '../../redux/boiler/boiler_actions';

class BoilerCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.boilerDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newBoiler = this.boilerDetail.getWrappedInstance().getWrappedInstance().getBoilerData();
    this.props.createBoiler(newBoiler);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create boiler')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BoilerDetail
            ref={ref => (this.boilerDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="hot-water-boiler-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreating ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const boilerState = state.hotWaterSystem.boiler;
  return {
    errorMessage: boilerState.errorMessage,
    isCreating: boilerState.isCreating,
  };
};

const mapDispatchToProps = dispatch => ({
  createBoiler: boiler =>
    dispatch(
      createBoiler(
        boiler.name,
        boiler.efficiency,
        boiler.type_id,
        boiler.description || '',
        boiler.image,
        boiler.cfp_value,
        boiler.cfp_unit,
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(BoilerCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/boiler/BoilerCreateModal.js